import React from 'react'

// Components
import ImgUtil from '../../../utils/img.utils'
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

// Styles
import * as styles from './style'

// Helpers
import { internalLinkHandler } from '../../../utils/link.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'
import { TileBox, renderAssets } from './subcomponents/threeTileComp'

const ThreeTiles = (props: any) => {
  if (!props.data) return null
  const {
    title,
    description,
    backgroundStatus,
    backgroundVideo,
    backgroundImage,
    tilesArray,
    threeTilesCta,
    threeTilesAnchor,
  } = props.data

  let animationAsset,
    videoType,
    videoId,
    start,
    videoUrl,
    videoPosterImg,
    bgVideoAltText,
    imageOverlay
  if (backgroundVideo) {
    animationAsset =
      backgroundVideo?.animationFile && backgroundVideo?.animationFile?.file
        ? backgroundVideo?.animationFile?.file?.url
        : ''

    if (backgroundVideo?.youtubeId) {
      videoType = 'youtube'
      videoId = backgroundVideo?.youtubeId
    } else if (backgroundVideo?.vimeoId) {
      videoType = 'vimeo'
      videoId = backgroundVideo?.vimeoId
    } else if (backgroundVideo?.videoUrl) {
      videoType = 'html-video'
      videoUrl = backgroundVideo?.videoUrl
    } else if (backgroundVideo?.tencentVideoUrl) {
      videoType = 'tencent-video'
      videoUrl = backgroundVideo?.tencentVideoUrl
    }
    start = backgroundVideo?.start
    videoPosterImg = backgroundVideo?.image?.file?.url
    bgVideoAltText = backgroundVideo?.altText
    imageOverlay = backgroundVideo?.imageOverlay
  }

  let bgImagePath, bgImageAltText
  if (backgroundImage) {
    bgImagePath = backgroundImage?.image?.file?.url
    bgImageAltText = backgroundImage?.altText
  }

  return (
    <styles.Tiles>
      {threeTilesAnchor?.identifier ? <span id={threeTilesAnchor?.identifier}></span> : null}
      <div className="ThreeTiles__Container" data-cy="three-tiles">
        <Typography className="ThreeTiles__MainTitle" type="header2">
          {formatInlineCode(title)}
        </Typography>
        <div className="ThreeTiles__VideoThumbnail">
          {backgroundStatus === 'Video' && (
            <div className="ThreeTiles__playVideo" data-cy="three-tiles-video">
              {renderAssets({
                animationAsset: animationAsset,
                videoId: videoId,
                videoUrl: videoUrl,
                videoPosterImg: videoPosterImg,
                videoType: videoType,
                bgVideoAltText: bgVideoAltText,
                start: start,
                imageOverlay: imageOverlay,
              })}
            </div>
          )}

          {backgroundStatus === 'Image' && (
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(bgImagePath, `width=600, height=335`)}
              alt={bgImageAltText}
              threshold={650}
            />
          )}
        </div>

        {tilesArray && (
          <div className="ThreeTiles__Cards">
            {tilesArray.map((item: any, index: String) => {
              return <TileBox data={item} index={index} key={index} />
            })}
          </div>
        )}

        {description || threeTilesCta ? (
          <div className="ThreeTiles__Bottom">
            {description && (
              <div className="ThreeTiles__MainDesc">{formatInlineCode(description)}</div>
            )}
            {threeTilesCta &&
              (threeTilesCta?.externalUrl || threeTilesCta?.internalLink) &&
              threeTilesCta?.text && (
                <Button
                  icon={true}
                  href={
                    threeTilesCta?.internalLink
                      ? internalLinkHandler(threeTilesCta?.internalLink)
                      : threeTilesCta?.externalUrl
                  }
                  text={threeTilesCta?.text}
                  type="text-link"
                  size="small"
                  theme={'light'}
                />
              )}
          </div>
        ) : null}
      </div>
    </styles.Tiles>
  )
}
export default ThreeTiles
